module.exports = __webpack_public_path__ + "img/face-6.cd755245.jpg";